import { cn } from "@/lib/utils";

const STATUS_MAP = {
  // Contract
  pending_assignment: { label: "Aguardando designação", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  pending_director_approval: { label: "Aguardando Diretora", cls: "bg-amber-50 text-amber-900 border-amber-200" },
  active: { label: "Em andamento", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  completed: { label: "Concluído", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  cancelled: { label: "Cancelado", cls: "bg-red-50 text-red-800 border-red-200" },

  // Risk
  on_track: { label: "No prazo", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  attention: { label: "Atenção", cls: "bg-amber-50 text-amber-900 border-amber-200" },
  risk: { label: "Em risco", cls: "bg-red-50 text-red-800 border-red-200" },

  // Document
  draft: { label: "Rascunho", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  pending_legal: { label: "Em revisão (Controle)", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  legal_changes_requested: { label: "Ajustes do Controle", cls: "bg-amber-50 text-amber-900 border-amber-200" },
  pending_director: { label: "Aguardando Diretora", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  director_changes_requested: { label: "Ajustes solicitados (Diretora)", cls: "bg-amber-50 text-amber-900 border-amber-200" },
  approved: { label: "Aprovado", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  published: { label: "Publicado ao cliente", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },

  // Meeting
  scheduled: { label: "Agendada", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  live: { label: "Ao vivo", cls: "bg-red-50 text-red-800 border-red-200" },
  done: { label: "Realizada", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },

  // Report
  pending_director_report: { label: "Aguardando Diretora", cls: "bg-amber-50 text-amber-900 border-amber-200" },
};

export const StatusBadge = ({ status, label, className }) => {
  const entry = STATUS_MAP[status] || { label: label || status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full border whitespace-nowrap",
        entry.cls,
        className,
      )}
      data-testid={`status-badge-${status}`}
    >
      {label || entry.label}
    </span>
  );
};
